module.exports = __webpack_public_path__ + "static/media/location-maps-letter-f.af2265e5.png";